export const MAX_MENU_ITEMS = 6
